import { useQuery } from "react-query"
import { get_approval_history } from "../../services/approvals";


const useApprovalHistory = (user_id) => {
    return useQuery(('get_approval_history'), ()=> get_approval_history(user_id))
}

export default useApprovalHistory;